import * as R from 'ramda';
import { createSelector } from 'reselect';

export default createSelector(
  R.path(['auth', 'userAKey']),

  R.identity,
);
